import { InjectionToken } from '@angular/core';
import { TranslationGroup } from './tanslation-group';

export const TRANSLATION_GROUP_TOKEN = new InjectionToken<TranslationGroup>("TranslationGroup");